import React, {
  useCallback,
  useEffect,
  useState,
} from "react";

import { Modal } from "react-bootstrap";

import { useSetRecoilState } from "recoil";

import {
  fetchKritikSaran,
} from "../../api";

import {
  FilterPagination,
  FilterSearch,
} from "../../components/layouts/TopContent";

import PageNoData from "../../components/pages/NoData";

import SectionPagination from "../../components/sections/Pagination";

import KritikSaranTable from "../../components/kritik/KritikSaranTable";

import KritikSaranDetail from "./KritikSaranDetail";

import { titleState } from "../../storage/pages";

const KritikSaranSaya = () => {
  /*
  |--------------------------------------------------------------------------
  | TITLE
  |--------------------------------------------------------------------------
  */

  const setTitle =
    useSetRecoilState(titleState);

  useEffect(() => {
    setTitle("Kritik & Saran Terkirim");
  }, [setTitle]);

  /*
  |--------------------------------------------------------------------------
  | STATE
  |--------------------------------------------------------------------------
  */

  const [kritikSaran, setKritikSaran] =
    useState({});

  const [page, setPage] = useState(1);

  const [paginate, setPaginate] =
    useState(10);

  const [search, setSearch] =
    useState("");

  /*
  |--------------------------------------------------------------------------
  | DETAIL MODAL
  |--------------------------------------------------------------------------
  */

  const [showDetail, setShowDetail] =
    useState(false);

  const [selectedData, setSelectedData] =
    useState(null);

  /*
  |--------------------------------------------------------------------------
  | FETCH
  |--------------------------------------------------------------------------
  */

  const fetchData = useCallback(async () => {
    try {
      const res = await fetchKritikSaran(
        page,
        `
          paginate=${paginate}
          &search=${search}
          &mode=saya
        `
      );

      if (res.data) {
        console.log(res.data);
        setKritikSaran(
        res.data.kritik_saran || res.data
        );
      }
    } catch (err) {
      console.error(err);
    }
  }, [page, paginate, search]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  /*
  |--------------------------------------------------------------------------
  | ACTION
  |--------------------------------------------------------------------------
  */

  const handleDetail = (data) => {
    console.log("DETAIL :", data);

    setSelectedData(data);

    setShowDetail(true);
  };

  return (
    <>
      {/* FILTER */}
      <div className="row mb-3">
        <div className="col-md-6">
          <FilterPagination
            onChange={(res) =>
              setPaginate(res)
            }
          />
        </div>

        <div className="col-md-6">
          <FilterSearch
            onChange={(res) =>
              setSearch(res)
            }
          />
        </div>
      </div>

      {/* TABLE */}
      {kritikSaran?.data &&
      kritikSaran?.data?.length > 0 ? (
        <>
          <KritikSaranTable
            data={kritikSaran}
            onDetail={handleDetail}
            showAction={true}
          />

          {/* PAGINATION */}
          {kritikSaran?.links &&
            kritikSaran?.links?.length >
              0 && (
              <SectionPagination
                links={
                  kritikSaran.links
                }
                onChangePage={(res) =>
                  setPage(res)
                }
              />
            )}
        </>
      ) : (
        <PageNoData />
      )}

      {/* DETAIL MODAL */}
      <Modal
        show={showDetail}
        onHide={() =>
          setShowDetail(false)
        }
        size="xl"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Detail Kritik & Saran
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <KritikSaranDetail
            kritikSaran={
              selectedData
            }
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default KritikSaranSaya;